import React from "react"
import TweetEmbed from "react-tweet-embed"

const TwitterEmbeds = ({ tweetId }) => {
    return (
        <TweetEmbed style={{ width: "100%" }} id={tweetId} />

        /* <div className="articleContent articleContent--twitter"
      dangerouslySetInnerHTML={{ __html: url }}>
    </div> */
    )
}

export default TwitterEmbeds
